import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

const RadioButtonGroup = (props) => {
	const TOOLTIP_LOCKED_TEXT = "Je antwoord is geblokkeerd omdat er reeds bestanden aan de vraag gekoppeld zijn. Indien je alsnog je antwoord wil veranderen moet je eerst alle documenten handmatig verwijderen.";
	const lockedText = props.lockedText ? props.lockedText : TOOLTIP_LOCKED_TEXT;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const labelInsideControl = props.labelInside;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = (props.label ? props.label : "") + (props.optional ? " (Optioneel)" : "");
	const value = props.value == null ? 'null' : (props.value === true || props.value === 'true') ? 'true' : (props.value === false || props.value === 'false') ? 'false' : props.value;
	const disabled = props.disabled || props.readonly || props.locked;
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} isInput={labelInsideControl} windowWidth={props.tooltipWindowWidth} windowAlignRight={props.tooltipWindowAlignRight} /> : null;
	const locked = props.locked ? <Tooltip text={lockedText} icon={types.TOOLTIP_ICON_LOCK} isLocked tooltipType={types.TOOLTIP_INFO} isInput isSecundaryTooltip /> : null;
	const validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const onChange = disabled ? null : props.onChange;
	const radioClassName = {
		"c-input": true,
		"radiobuttonlist": true,
		"disabled": disabled,
		"inline": props.horizontal,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING
	};
	const options = props.items.map((item, i) =>
		<div key={props.name + i} className="c-input__group">
			<input type="radio" name={props.name} onChange={onChange} value={item.value}
				checked={item.value.toString() === value.toString()} id={props.name + i} disabled={disabled} />
			<label htmlFor={props.name + i}>{item.label}</label>
		</div>);

	const style = props.noBorder ? { border: 0 } : null;

	const component = (
		<div value={props.value} className={classnames(sizeClassName)}>
			<div className={classnames(radioClassName)}>
				{labelInsideControl ? <div className="c-input__label has-value">{label}</div> : ""}
				<div className="c-input__field" style={style}>{options}</div>
				{labelInsideControl ? info : ""}{locked}
			</div>
			{validation}
		</div>);

	return (labelInsideControl
		?
		component
		:
		<div>
			<h5 className="c-fieldset__subheader">{label} {info}</h5>
			{component}
		</div>

	);
};

RadioButtonGroup.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	items: PropTypes.array.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
		PropTypes.number
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	horizontal: PropTypes.bool,
	noBorder: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool,
	optional: PropTypes.bool,
	labelInside: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string
};

export default RadioButtonGroup;
